import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block text-center mb-3 bold">Трусливая старуха</p>
      

      <p class="poem-block mb-5">
				Что может быть гаже трусливой старухи? <br/>
				Мозги её к голосу разума глухи, <br/>
				Служить её давно перестали они; <br/>
				Да разве служили и в давние дни? <br/>
				Тупая послушная девочка в школе <br/>
				На тройки училась, и знала не боле <br/>
				Чем текст из учебника в несколько строк, <br/>
				Да это и то на один лишь урок. <br/>
				Но как половая к ней зрелость пришла, <br/>
				Как пышный бурьян тут она расцвела <br/>
				И мальчика выбрала с точным прицелом, <br/>
				Чтоб был, как она, занимался бы делом <br/>
				И ей не перечил, а дом наживал, <br/>
				Чтоб был у него тот звериный оскал, <br/>
				Что будет хранить весь нажитый их дом <br/>
				Со всем отвоёванным в мире добром. <br/>
				Зубами, клыками в нелёгкой борьбе <br/>
				Они вырывали местечко себе. <br/>
				И детки пошли, папа с мамой точь-в-точь: <br/>
				Придурочный сын, туповатая дочь… <br/>
				Нашли и себе они «место в строю»: <br/>
				В борьбе обрели они сущность свою <br/>
				И выгрызли место, и выгрызли дом, <br/>
				И жирный достаток царил в доме том. <br/>
				Но стала сдавать постаревшая мать; <br/>
				Зачем же обузу на плечи им брать? <br/>
				Не выгодно больше, она не нужна… <br/>
				Так старая бабка осталась одна: <br/>
				Нет мужа давно, дети-внуки ушли, <br/>
				Бурьяном все мысли её поросли, <br/>
				Ума отродясь не бывало и нет, <br/>
				Но те́лик всегда даст полезный совет, <br/>
				Научит, что думать, что сделать, сказать, <br/>
				Кому покоряться, кому отказать… <br/>
				И в ней возродилась собачья душа: <br/>
				Уже не кусаться, а лаять спеша, <br/>
				Она по указке боится и бдит, <br/>
				И хвост поджимает, и грозно рычит, <br/>
				Работая так до конца своих дней <br/>
				Бессмысленным зомби зловещих людей. 
      </p>
			
			
      <p class="poem-block text-center mb-3 bold">Воинственный старик</p>
      

      <p class="poem-block mb-3">
				На улице старик плешивый, <br/>
				Облезлый, старый и паршивый <br/>
				Кричит, что надо власть забрать, <br/>
				Всех супостатов изрубать, <br/>
				Особенно же одного, <br/>
				Кто в бункер спрятался. Того <br/>
				Он сам бы хоть сто тысяч раз <br/>
				Пронзил в живот, пронзил бы в глаз, <br/>
				И руки-ноги отрубил, <br/>
				И кровь бы выпустил из жил… <br/>
				Но вот пришёл его черёд <br/>
				И он продвинулся вперёд. <br/>
				Вот первый в очереди он, <br/>
				Вот и допущен он в салон, <br/>
				Где раздают тряпьё и снедь, <br/>
				Чтоб без штанов не околеть <br/>
				И чтоб дрожащая рука <br/>
				Могла схватить хоть два куска… <br/>
				Но где же гонор весь его? <br/>
				«Врага» забывши своего, <br/>
				Он жалко просит что-нибудь, <br/>
				Чтобы прикрыть гузно и грудь: <br/>
				Кальсоны, куртку, пару брюк <br/>
				Да пирожков десяток штук… <br/>
				Родился он в 42-ом, -- <br/>
				И кто мог быть его отцом? <br/>
				Презренный дезертир войны? <br/>
				Ведь были воины нужны <br/>
				Стране в тот страшный смертный час, <br/>
				Когда весь мир пошёл на нас: <br/>
				Не открывали фронт второй, <br/>
				Оставив русских на убой. <br/>
				Иль с немцем мать его легла <br/>
				За ту же снедь с его стола? <br/>
				И вот и он за стол и кров <br/>
				Подачку просит у врагов. <br/>
				В стране великой вырос он, <br/>
				Но сам ничтожным был рождён: <br/>
				Ни памяти, ни чести нет. <br/>
				– На свалку, вон! – ему ответ. 
      </p>
      
    </div>
    `
  )
}

const itemDate = {
  rus: '27 февраля 2022'
}

const itemName = {
  rus: 'Диптих'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;